#import "../fragments/changelog-event-fragment.graphql"

query GetChangeLog($entityId: ID!) {
    changelog(entityId: $entityId) {
        totalCount
        pageInfo {
            endCursor
            hasNextPage
        }
        edges {
            node {
                ...ChangelogEventFragment
            }
        }
    }
}
